import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { AccountingCodeEntryMapping, AccountingCodeList } from '../../../../core/model';
import { Occ } from '../../../../core/occ';
import { ConverterService } from '../../../../core/util';
import { ACCOUNTING_CODE_LIST_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class CartAccountingCodesConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  setAccountingCodes(userId: string, cartId: string, entries: AccountingCodeEntryMapping[]): Observable<any> {
    const url = this.occEndpointsService.buildUrl('cartEntriesMultipleAccountingCode', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
      },
    });

    return this.httpClient.patch<void>(url, { mappings: entries });
  }

  loadAccountingCodeList(userId: string): Observable<AccountingCodeList> {
    const url = this.occEndpointsService.buildUrl('accountingCodes', {
      urlParams: {
        userId,
      },
      queryParams: {
        fields: 'FULL',
      },
    });
    return this.httpClient.get<Occ.AccountingCodeList>(url).pipe(this.converterService.pipeable(ACCOUNTING_CODE_LIST_NORMALIZER));
  }
}
